<div *ngIf="messageService.data" [ngClass]="messageService.data.success ? 'alert-success' : 'alert-danger'" class="alert" [innerHTML]="messageService.data.message"></div>
